import client from "./client";

// 모집정보 리스트
export const recruitList = (locale, search) =>
  client.post(`/api/${locale}/recruit/list`, search);

// 내가 참여 가능한 모집정보
export const recruitMyList = locale =>
  client.post(`/api/${locale}/recruit/mylist`);
